import React, { useRef } from "react";
import { useEffect, useState } from "react";
// import "./investmentDetial.scss";
import Sidebar from "../../../Sidebar";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../../../../../components/Loader/Loader";
import noImg from "../../../../../assets/noImage.jpeg";
import { toast } from "react-toastify";
import ImgPreviewSpon from "./ImgPreviewSpon";

function MemberTeamDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const sponser_id = location?.state?.investment;
  console.log(sponser_id, "user");

  const [hideSvg, setHideSvg] = useState(false);
  const handleSvg = () => {
    setHideSvg(!hideSvg);
  };

  const [investmentDetail, setInvestmentDetail] = useState([]);
  const [loading, setLoading] = useState(true);

  //   function for fetching the investment details
  const fetchInvestmentDetail = async () => {
    console.log("helllllo");
    setLoading(true);
    const url = `https://ballersapi.ballerslife.co/api/v1/member/get_sponsee_team_details?team_spon_id=${sponser_id}`;

    const accessToken = window.localStorage.getItem("access_token");
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const data = await response.json();
      console.log(data);
      if (response.status === 200) {
        setLoading(false);
        setInvestmentDetail(data[0]);
      } else {
        toast.error(data.detail);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchInvestmentDetail();
  }, []);

  const formatNumber = (num) => {
    let formattedNumber;
    if (num >= 1000000000) {
      formattedNumber = (num / 1000000000).toFixed(1) + "B";
    } else if (num >= 1000000) {
      formattedNumber = (num / 1000000).toFixed(1) + "M";
    } else if (num >= 1000) {
      formattedNumber = (num / 1000).toFixed(1) + "K";
    } else {
      return num?.toString();
    }
    if (
      formattedNumber.endsWith(".0K") ||
      formattedNumber.endsWith(".0M") ||
      formattedNumber.endsWith(".0B")
    ) {
      formattedNumber =
        formattedNumber.slice(0, -3) + formattedNumber.slice(-1);
    }

    return formattedNumber;
  };

  return (
    <div className="dashMain">
      <div className="sideBar">
        <Sidebar />
      </div>
      {hideSvg ? (
        <div className="sideBarMobile">
          <Sidebar />
        </div>
      ) : (
        <div></div>
      )}
      <div className="content">
        {loading ? (
          <Loader />
        ) : (
          <div>
            <div className="goBackSvg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#FFBF00"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-chevron-left"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <path d="m15 18-6-6 6-6" />
              </svg>
            </div>
            <div className="logoBtnMain">
              <div className="clubLogoMain">
                <>
                  {investmentDetail.club_logo_url === null ? (
                    <img src={noImg} alt="" className="clubLogo" />
                  ) : (
                    <img
                      src={investmentDetail.image_url}
                      alt=""
                      className="clubLogo"
                    />
                  )}
                </>
              </div>
            </div>
            <div className="invOverviewMain">
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">TEAM NAME :</p>
                <p
                  className="invOverviewContSecond"
                  dangerouslySetInnerHTML={{
                    __html: investmentDetail.sponsee_team_name,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">SPORTS CATEGORY :</p>
                <p
                  className="invOverviewContSecond"
                  dangerouslySetInnerHTML={{
                    __html: investmentDetail.sport_category,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst"> LEAGUE NAME :</p>
                <p
                  className="invOverviewContSecond"
                  dangerouslySetInnerHTML={{
                    __html: investmentDetail.league_name,
                  }}
                />
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">SPONSORSHIP AMOUNT :</p>
                <p
                  className="invOverviewContSecond"
                  dangerouslySetInnerHTML={{
                    __html: `$ ${formatNumber(
                      investmentDetail.sponsorship_amount
                    )}`,
                  }}
                />
                $
              </div>
              <div className="invOverviewCont">
                <p className="invOverviewContFirst">INVESTMENT TYPE :</p>
                <p
                  className="invOverviewContSecond"
                  dangerouslySetInnerHTML={{
                    __html: investmentDetail.investment_type,
                  }}
                />
              </div>
            </div>
            {/* sponsorship highlight */}
            {investmentDetail.sponsorship_highlights === undefined ||
            investmentDetail.sponsorship_highlights === "<p>NA</p>" ||
            investmentDetail.sponsorship_highlights === "<p>na</p>" ? (
              ""
            ) : (
              <div className="invOverviewMain">
                <div className="invOverviewContThird">
                  <p className="invOverviewContFirst">
                    SPONSORSHIP HIGHLIGHT :
                  </p>
                  <p
                    className="invOverviewContSecond"
                    dangerouslySetInnerHTML={{
                      __html: investmentDetail.sponsorship_highlights,
                    }}
                  />
                </div>
              </div>
            )}
            {/* sponsorship thesis */}
            {investmentDetail.sponsorship_thesis === undefined ||
            investmentDetail.sponsorship_thesis === "<p>NA</p>" ||
            investmentDetail.sponsorship_thesis === "<p>na</p>" ? (
              ""
            ) : (
              <div className="invOverviewMain">
                <div className="invOverviewContThird">
                  <p className="invOverviewContFirst">SPONSORSHIP THESIS :</p>
                  <p
                    className="invOverviewContSecond"
                    dangerouslySetInnerHTML={{
                      __html: investmentDetail.sponsorship_thesis,
                    }}
                  />
                </div>
              </div>
            )}
            {/* Team overview */}
            {investmentDetail.team_overview === undefined ||
            investmentDetail.team_overview === "<p>NA</p>" ||
            investmentDetail.team_overview === "<p>na</p>" ? (
              ""
            ) : (
              <div className="invOverviewMain">
                <div className="invOverviewContThird">
                  <p className="invOverviewContFirst">TEAM OVERVIEW :</p>
                  <p
                    className="invOverviewContSecond"
                    dangerouslySetInnerHTML={{
                      __html: investmentDetail.team_overview,
                    }}
                  />
                </div>
              </div>
            )}

            {/* MANAGEMET DETAILS */}
            {investmentDetail.management_details === undefined ||
            investmentDetail.management_details === "<p>NA</p>" ||
            investmentDetail.management_details === "<p>na</p>" ? (
              ""
            ) : (
              <div className="invOverviewMain">
                <div className="invOverviewContThird">
                  <p className="invOverviewContFirst">MANAGEMET DETAILS :</p>
                  <p
                    className="invOverviewContSecond"
                    dangerouslySetInnerHTML={{
                      __html: investmentDetail.management_details,
                    }}
                  />
                </div>
              </div>
            )}
            {/* future plans */}
            {investmentDetail.future_plans === undefined ||
            investmentDetail.future_plans === "<p>NA</p>" ||
            investmentDetail.future_plans === "<p>na</p>" ? (
              ""
            ) : (
              <div className="invOverviewMain">
                <div className="invOverviewContThird">
                  <p className="invOverviewContFirst">FUTURE PLANS :</p>
                  <p
                    className="invOverviewContSecond"
                    dangerouslySetInnerHTML={{
                      __html: investmentDetail.future_plans,
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default MemberTeamDetail;
